import PropTypes from "prop-types"

import { RetailPrice } from "areas/cart/components"
import Financing from "areas/product/jewlr/wizard-header/financing"
import { IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const Price = ({ dataCyType, item }) => {
  const onSale = item.on_sale

  return (
    <div>
      {IS_JEWLR() ? (
        <>
          {onSale && (
            <p className="text-sale text-10 tablet:text-16 tablet:leading-none font-bold leading-normal tracking-wider">
              SALE
            </p>
          )}
          <p
            className={cn(
              "text-30 tablet:text-32 font-light leading-none",
              onSale ? "text-sale" : "text-black"
            )}
            data-cy={`cart-line-item-price-${dataCyType}-${item.style_code}`}
            data-ge-basket-productsaleprice
          >
            {to_currency(item.price)}
          </p>
          {onSale && (
            <RetailPrice>
              <strike data-ge-basket-productlistprice>
                {to_currency(item.regular_price)}
              </strike>
              {/* <>RETAIL {to_currency(item.retail_price)}</> */}
            </RetailPrice>
          )}
          <div className="mt-4">
            <Financing price={item.price * 100} />
          </div>
        </>
      ) : (
        <p
          className={cn(
            "text-30 tablet:text-32 font-light leading-none",
            onSale ? "text-sale" : "text-black"
          )}
          data-cy={`cart-line-item-price-${dataCyType}-${item.style_code}`}
        >
          {to_currency(item.price)}
        </p>
      )}
    </div>
  )
}

Price.propTypes = {
  dataCyType: PropTypes.string,
  item: PropTypes.object,
}

export default Price
